import { MovieEditOutlineIcon } from './MovieEditOutlineIcon';

/**
 * author: Christopher Schreiner
 * id 16912257-3D89-4630-9CC5-1FB0EB4A112C
 * name movie-edit-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-edit-outline.svg
 * tags
 * - Video / Movie 
 * - Edit / Modify 
 */
export const SlateEditOutlineIcon = MovieEditOutlineIcon;
export default SlateEditOutlineIcon